import { Avatar } from '@mui/material';
import { grey } from '@mui/material/colors';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';
import { RESULTADO_JULGAMENTO } from '@/dominio/ResultadoJulgamento';

export default class FiltroSituacaoApreciacao extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    corFundo = grey[600];

    get label() {
        return 'Apreciação';
    }

    getIconeFiltroRapido(cor) {
        return (
            <Avatar
                variant="rounded"
                style={{
                    width: '26px',
                    height: '26px',
                    fontWeight: '600',
                    fontSize: '0.98rem',
                    backgroundColor: cor
                }}
            >
                A
            </Avatar>
        );
    }

    opcoesFiltro = this.#carregarOpcoes();

    filtroRapido = { opcoes: this.getOpcoesFiltro('valor', 'cor') };

    #carregarOpcoes() {
        const ordemPrimeirasOpcoes = [
            RESULTADO_JULGAMENTO.NAO_JULGADO.codigo,
            RESULTADO_JULGAMENTO.JULGADO.codigo,
            RESULTADO_JULGAMENTO.JULGADO_OBSERVACAO.codigo,
            RESULTADO_JULGAMENTO.JULGADO_ALTERACAO_VOTO.codigo
        ];
        const primeirasOpcoesExistentes = this.#validarOpcoes(ordemPrimeirasOpcoes);
        let opcoes = [];
        let indicesInseridos = [];

        this.store.rootStore.dominioStore.tiposResultadoJulgamento.forEach((resultadoApreciacao) => {
            let indice = primeirasOpcoesExistentes.findIndex((codigoOpcao) => codigoOpcao === resultadoApreciacao.codigo);
            let item = this.#montarObjOpcaoFiltroRapidoSituacaoApreciacao(resultadoApreciacao);

            if (indice > -1) {
                indice = this.#calcularIndice(indice, indicesInseridos);
                opcoes.splice(indice, 0, item);
                indicesInseridos.push(indice);
            } else {
                opcoes.push(item);
            }
        });

        return opcoes;
    }

    #montarObjOpcaoFiltroRapidoSituacaoApreciacao(resultadoApreciacao) {
        return {
            valor: resultadoApreciacao.codigo,
            cor: this.corFundo,
            icone: (
                <Avatar
                    variant="rounded"
                    style={{
                        width: '36px',
                        height: '26px',
                        fontWeight: '600',
                        fontSize: '0.96rem',
                        backgroundColor: this.corFundo
                    }}
                >
                    {this.#abreviarDescricao(resultadoApreciacao.descricao)}
                </Avatar>
            )
        };
    }

    #calcularIndice(indice, indicesInseridos) {
        let somaAnterioresInseridos = 0;

        indicesInseridos.forEach((indiceInserido) => {
            if (indiceInserido < indice) {
                somaAnterioresInseridos++;
            }
        });

        let indiceCalculado = indice + (somaAnterioresInseridos - indice);

        return indiceCalculado;
    }

    #validarOpcoes(opcoes) {
        let opcoesEncontradas = [];

        opcoes.forEach((codigoOpcao) => {
            this.store.rootStore.dominioStore.tiposResultadoJulgamento.forEach((resultadoApreciacao) => {
                if (codigoOpcao === resultadoApreciacao.codigo) {
                    opcoesEncontradas.push(codigoOpcao);
                }
            });
        });

        return opcoesEncontradas;
    }

    #abreviarDescricao(descricao) {
        const exclusoes = ['com', 'da', 'de', 'do', 'em'];
        const excecoes = [
            { descricao: 'Suspenso', abreviacao: 'Sp' },
            { descricao: 'Sobrestado', abreviacao: 'Sb' },
            { descricao: 'Adiado', abreviacao: 'Ad' }
        ];

        let descricaoAbreviada = undefined;
        excecoes.forEach((excecao) => {
            if (descricao.toLowerCase() === excecao.descricao.toLowerCase()) {
                descricaoAbreviada = excecao.abreviacao;
            }
        });

        if (descricaoAbreviada !== undefined) {
            return descricaoAbreviada;
        }

        descricaoAbreviada = descricao
            .split(' ')
            .map((palavra) => {
                return palavra.length === 1 || exclusoes.includes(palavra) ? '' : palavra.charAt(0).toUpperCase();
            })
            .join('');

        return descricaoAbreviada;
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return registro.resultadoJulgamento?.codigo;
    }

    getDescricao(valor) {
        if (!valor) {
            return '';
        }

        const resultadoApreciacao = this.store.rootStore.dominioStore.tiposResultadoJulgamento.find(
            (tipoResultado) => tipoResultado.codigo === valor
        );

        return resultadoApreciacao ? resultadoApreciacao.descricao : 'Resultado de apreciação desconhecido: ' + valor;
    }
}
